import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { contentPageStore } from 'entities/excursions/content-page/model/content-page-store'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import s from './guide-details.module.scss'

type Props = {
  excursionDetails: IExcursionDetails
}

export const GuideDetails = ({ excursionDetails }: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const viewDetails = (details: string) => {
    contentPageStore.setContentState(t('more'), details)

    navigate(RoutingPaths.excursion.contentPage.path())
  }

  const renderDetailsItem = (title: string, details: string) => (
    <div
      className={s.moreDetailsItem}
      onClick={() => viewDetails(details)}
    >
      <p className={s.moreDetailsText}>{title}</p>
      <AppIcon id={AllIcons.ARROW_RIGHT} />
    </div>
  )
  return (
    <Paper>
      <div className={s.moreDetails}>
        <h4 className={s.moreDetailsTitle}>{t('more')}</h4>

        <div className={s.moreDetailsList}>
          {excursionDetails.included &&
            renderDetailsItem(
              t('excursions.what_include'),
              excursionDetails.included,
            )}

          {excursionDetails.not_included &&
            renderDetailsItem(
              t('excursions.what_not_include'),
              excursionDetails.not_included,
            )}
        </div>
      </div>
    </Paper>
  )
}
